module.exports = __webpack_public_path__ + "img/sv.93106519.png";